
import Vue from "vue";
import Sidebar from "primevue/sidebar";
import LottieAnimation from "@/components/LottieAnimationsComponent.vue";
import { PatientMessagesPayloadViewModel } from "@/interfaces/PatientMessagesPayloadViewModel";
import { PropType } from "vue";
import store from "@/store";
import { mapGetters } from "vuex";
import MultiSelect from "primevue/multiselect";
import PharmacyMedicinePickerComponent from "../components/PharmacyMedicinePickerComponent.vue";
import PharmacyMedicineSearchComponent from "@/components/PharmacyMedicineSearchComponent.vue";
import { SubscriptionTransferViewModel } from "@/interfaces/SubscriptionTransferViewModel";

enum view {
  chooseTransferMethod = 0,
  transferFromPharmacy = 1,
  transferRequestSuccess = 2,
  sendFromDoctor = 3,
}

export default Vue.extend({
  name: "TransferMedicationDirections",
  props: {
    displayChoicesSidebar: { type: Boolean, default: false },
    payload: Object as PropType<PatientMessagesPayloadViewModel>,
  },
  data() {
    return {
      view: view.chooseTransferMethod,
      pharmacyName: "" as string,
      state: "" as string,
      phone: "" as string,
      notes: "" as string,
      isSubmitted: false,
      formattedMessage: "" as string,
      folderType: 0,
      selectedDrugs: [],
      displayAddMedication: false as boolean,
      selectedMedicationData: {},
    };
  },
  computed: {
    ...mapGetters({
      MarketplaceEstimates: "getMarketplaceEstimates",
      Content: "getContent",
    }),
    formattedEstimates() {
      return this.MarketplaceEstimates.map((item) => ({
        ...item,
        drugName: item.drugName.trim().charAt(0).toUpperCase() + item.drugName.trim().slice(1).toLowerCase(),
      }));
    },
  },
  methods: {
    setView(view: number) {
      this.view = view;
    },
    formatName(name: string) {
      console.log(name);
      if (typeof name !== "string") return "";
      name = name.trim();
      const lowerCaseText = name.toLowerCase();
      console.log(lowerCaseText);
      return lowerCaseText.charAt(0).toUpperCase() + lowerCaseText.slice(1);
    },
    closeSidebar() {
      this.$emit("closeSidebar");
      this.view = 0;
    },
    closeAddMedication(payload) {
      console.log("Payload:", payload);
      if (!Array.isArray(payload)) {
        this.displayAddMedication = false;
        return;
      }
      if (!Array.isArray(this.selectedDrugs)) {
        this.selectedDrugs = [];
      }

      // Only add items that aren't already selected
      payload.forEach((item) => {
        if (!this.selectedDrugs.some((i) => i.id === item.id)) {
          this.selectedDrugs.push(item);
        }
      });
      this.displayAddMedication = false;
    },
    openAddMedication() {
      this.displayAddMedication = true;
    },
    selectMedication(medicationData) {
      this.selectedMedicationData = medicationData;
    },
    isValidPhone(phone: string): boolean {
      return /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(phone);
    },
    async submitForm() {
      this.isSubmitted = true;
      if (!this.pharmacyName || !this.state || !this.isValidPhone(this.phone) || this.selectedDrugs.length === 0) {
        return;
      }

      const vm: SubscriptionTransferViewModel = {
        pharmacyName: this.pharmacyName,
        state: this.state,
        phone: this.phone,
        selectedDrugs: this.selectedDrugs.map((item) => ({
          drugName: item.drugName,
          dose: item.dose,
        })),
      };

      this.$emit("transferStarted");
      const result = await store.dispatch("TransferMedication", vm);
      if (!result) {
        this.$bvToast.toast("An error has occurred!", { title: "Error", autoHideDelay: 3000, appendToast: true, variant: "danger", solid: true, toaster: "b-toaster-top-center" });
        return;
      }
      this.setView(2);
    },
  },
  components: {
    Sidebar,
    LottieAnimation,
    MultiSelect,
    PharmacyMedicinePickerComponent,
    PharmacyMedicineSearchComponent,
  },
});
